import React, { useState, useContext, useEffect } from 'react'
import AdminContext from '../../../StateContext/Application';
import "../../page.css"
const Requisitions = () => {
  const context = useContext(AdminContext);
  const { AddExpenses } = context;
  const [expenses, setExpenses] = useState([]);
  const [totalApproved, setTotalApproved] = useState(0);
  useEffect(() => {
    GetExpenses();
  }, [])
  const GetExpenses = async () => {
    try {
      let data = await AddExpenses([], "expenselist");
      setExpenses(data);
      const total = data.reduce((acc, curr) => acc + Number(curr.Approved_Amount || 0), 0);
      setTotalApproved(total);
    } catch (error) {
      console.error("Error in GetProjects:", error);
    }
  };

  return (
    <>
      <div style={{ marginLeft: '2rem', marginTop: '1rem', fontSize: '1.5rem', fontWeight: 'bold' }}>Expense List</div>
      <div style={{ marginTop: '1rem' }}>
        <tabel className="table table-primary" style={{ marginLeft: '2rem', marginTop: '1rem' }}>
          <thead>
            <tr>
              <th>Sr.No.</th>
              <th>Expense Type</th>
              <th>Project Name</th>
              <th>Requested By</th>
              <th>Amount Spent</th>
            </tr>
            {expenses.map((expense, index) => (
              <tr key={expense.id}>
                <td>{index + 1}</td>
                <td>{expense.Expense_Type}</td>
                <td>{expense.Project_Name}</td>
                <td>{expense.User_Name}</td>
                <td>{expense.Approved_Amount}</td>
              </tr>
            ))}
          </thead>
        </tabel>
        <div style={{ marginLeft: '2rem', marginTop: '1rem', fontWeight: 'bold', fontSize: '1.2rem' }}>
          Total Expenses: ₹{totalApproved.toLocaleString()}
        </div>
      </div>
    </>
  )
}

export default Requisitions